import { render, staticRenderFns } from "./approved-opcrs.vue?vue&type=template&id=2b393d7a&"
import script from "./approved-opcrs.vue?vue&type=script&lang=js&"
export * from "./approved-opcrs.vue?vue&type=script&lang=js&"
import style0 from "./approved-opcrs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports